import { render, staticRenderFns } from "./interiorConfirmNewsSuccess.vue?vue&type=template&id=3d2b5cd4&scoped=true&"
import script from "./interiorConfirmNewsSuccess.vue?vue&type=script&lang=js&"
export * from "./interiorConfirmNewsSuccess.vue?vue&type=script&lang=js&"
import style0 from "./interiorConfirmNewsSuccess.vue?vue&type=style&index=0&id=3d2b5cd4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2b5cd4",
  null
  
)

export default component.exports